import { useEffect, useState } from "react";

/** The tab is in front (a hidden tab neither polls nor plays). */
export function usePageVisible(): boolean {
  const [visible, setVisible] = useState(() => document.visibilityState !== "hidden");
  useEffect(() => {
    const on = () => setVisible(document.visibilityState !== "hidden");
    document.addEventListener("visibilitychange", on);
    return () => document.removeEventListener("visibilitychange", on);
  }, []);
  return visible;
}

/** The clock, re-read every minute and whenever the tab comes back (a stale radar must not linger as "Jetzt"). */
export function useNow(intervalMs = 60_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const tick = () => setNow(Date.now());
    const id = setInterval(tick, intervalMs);
    const on = () => {
      if (document.visibilityState !== "hidden") tick();
    };
    document.addEventListener("visibilitychange", on);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", on);
    };
  }, [intervalMs]);
  return now;
}
